import React from 'react';
import { useTranslation } from 'react-i18next';
import { useFieldArray } from 'react-hook-form';
import { MdAdd } from 'react-icons/md';
import styled from 'styled-components';

import { HeaderText } from '../../components/Modals';
import { Flex } from '../../components/ui/Flex';
import { Separator } from '../../components/ui/Separator';
import { ButtonBodyVariant } from '../../components/ui/ButtonVariant';
import TechnicianNoteForm from './TechnicianNoteForm';

const TechnicianNotesSection = ({ form, disabled = false }) => {
  const { t } = useTranslation();
  const { fields, append, remove } = useFieldArray({
    control: form.control,
    name: 'technician_note_items'
  });

  const addNote = () => {
    append({ note: '', is_new: true });
  };

  return (
    <Flex direction="column" gap="8px">
      <Separator orientation="horizontal" />
      <Flex justify="space-between" alignItems="center">
        <HeaderText alt style={{ marginBottom: 0 }}>
          {t('Technician Notes')}
        </HeaderText>
        {!disabled && (
          <ButtonBodyVariant type="button" variant="ghost" onClick={addNote}>
            <MdAdd size={18} style={{ marginRight: '4px' }} />
            {t('Add Note')}
          </ButtonBodyVariant>
        )}
      </Flex>

      {fields.length === 0 && (
        <NoNotesSection>
          {t('No notes added yet. Click "Add Note" to add one.')}
        </NoNotesSection>
      )}

      {fields.map((field, index) => (
        <TechnicianNoteForm
          key={field.id}
          form={form}
          index={index}
          onRemove={remove}
          canRemove={fields.length > 0}
          disabled={disabled}
        />
      ))}

      {!disabled && fields.length > 0 && (
        <ButtonBodyVariant type="button" variant="ghost" onClick={addNote}>
          <MdAdd size={18} style={{ marginRight: '4px' }} />
          {t('Add Note')}
        </ButtonBodyVariant>
      )}
    </Flex>
  );
};

export default TechnicianNotesSection;

const NoNotesSection = styled.div`
  padding: 16px;
  text-align: center;
  color: #8898aa;
  border: 1px dashed #d8dbe0;
  border-radius: 8px;
`;
